import { render, staticRenderFns } from "./RemarkList.vue?vue&type=template&id=bc30be06&scoped=true"
import script from "./RemarkList.vue?vue&type=script&lang=js"
export * from "./RemarkList.vue?vue&type=script&lang=js"
import style0 from "./RemarkList.vue?vue&type=style&index=0&id=bc30be06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc30be06",
  null
  
)

export default component.exports